import { showMemberPriceTip } from '../../../utils/price';
import './index.scss';

export class ProductSetPickerPayment extends HTMLElement {
  constructor() {
    super();
    this.model = {};
  }
  updateModel(model) {
    this.model = model;
    this.render();
  }
  render() {
    const { product, finishSelected, checkoutPriceLabel } = this.model;

    const memberPriceSection = showMemberPriceTip(product)
      ? `<a class="member-info" href="/users/sign_in">
           <span>${product.member_price.label}</span>
           <span>${window.shopline.i18next.t('Member Only', { ns: 'translation' })}</span>
         </a>`
      : '';

    const template = `
      <div>
        <span class="payment">${checkoutPriceLabel}</span>
        <span class="original">${finishSelected ? product.price.label : ''}</span>
      </div>
      ${memberPriceSection}
    `;
    this.innerHTML = template;
  }
}

if (!customElements.get('product-set-picker-payment')) {
  customElements.define('product-set-picker-payment', ProductSetPickerPayment);
}
